import React from 'react'
import { ReactComponent as BackArrow } from '../../styles/svg-components/back-arrow.svg';
import { IconButton } from '../../components';
import './SignupHeader.scss';

export const SignupHeader = (props) => {
  return (
    <div className="signup-header">
      <IconButton icon={() => <BackArrow className="back-arrow"></BackArrow>} onClick={props.onClick}></IconButton>
      <h1>{props.pageTitle}</h1>
    </div>
  );
};

export default SignupHeader;
